const internalRoot = '/internal';
const appRoutes = {
    root: '/',
    login: {
        root: '/',
    },
    forgotPassword: {
        root: '/forgot-password',
        verification: '/otp-verification',
        reset: '/password-reset',
    },
    internal: {
        root: `${internalRoot}/dashboard`,
        returnProcessing: `${internalRoot}/return-processing`,
        reports: `${internalRoot}/reports`,
        help: `${internalRoot}/help`,
        faqs: `${internalRoot}/faqs`,
        ownedCases: {
            root: `${internalRoot}/owned-cases`,
            all: `${internalRoot}/owned-cases/cases`,
            pendingBankCases: `${internalRoot}/owned-cases/pending-bank-cases`,
            workFlowHistory: `${internalRoot}/owned-cases/workflow-history`,
        },
        caseMgt: {
            root: `${internalRoot}/case-management`,
            allCases: `${internalRoot}/case-management/all-cases`,
            rootCauseAnalysis: `${internalRoot}/case-management/root-cause-analysis`,
            closedCases: `${internalRoot}/case-management/closed-cases`,
            unassignedBreachedCases: `${internalRoot}/case-management/unassigned-breached-cases`,
            bank2BankBreachedCases: `${internalRoot}/case-management/bank-to-bank-breached-cases`,
            teamLeadAssignedCases: `${internalRoot}/case-management/teamlead-assigned-cases`,
            reportedInstitutions: `${internalRoot}/case-management/reported-institutions`,
            escalatedCases: `${internalRoot}/case-management/escalated-cases`,
        },
        category: {
            root: `${internalRoot}/category`,
            subCategories: `${internalRoot}/category/sub-categories`,
            all: `${internalRoot}/category/all`,
        },
        users: {
            root: `${internalRoot}/users`,
            all: `${internalRoot}/users/all`,
            external: `${internalRoot}/users/external`,
            create: `${internalRoot}/users/create`,
            createExternal: `${internalRoot}/users/external/create`,

            createRoles: `${internalRoot}/create-role`,
            userRoles: `${internalRoot}/roles`,
            audits: `${internalRoot}/audits`,
            createPermissions: `${internalRoot}/create-permission`,
            userPermissions: `${internalRoot}/permissions`,
            teams: `${internalRoot}/teams`,
            createTeams: `${internalRoot}/create-team`,
        },
        institutions: {
            root: `${internalRoot}/institution`,
            all: `${internalRoot}/institution/all`,
            create: `${internalRoot}/institution/create`,
            createRoles: `${internalRoot}/institution/create-role`,
            institutionTypes: `${internalRoot}/institution/types`,
            institutionAdmins: `${internalRoot}/institution/admins`,
            regulatoryDirectives: `${internalRoot}/institution/regulatory-directives`,
            sanctions: `${internalRoot}/institution/sanctions`,
            warnings: `${internalRoot}/institution/warnings`,
            technicalSessions: `${internalRoot}/institution/technical-sessions`,
            createInstitutionAdmins: `${internalRoot}/institution/create-admin`,
        },
    },
    fi: {
        root: '/returns',
        returns: '/returns',
        reports: '/query-reports',
        escalatedCases: '/escalated-cases',
    },
};

export default appRoutes;
